import {Action} from "redux";
import {GetAllClientBookmarkByClientRequest} from "../request/client_bookmark_request";
import {GetAllClientBookMarkByClientResponse} from "../response/client_bookmark_response";

export enum ClientClientBookmarksActionType {
    REQUEST_GET_ALL_CLIENT_BOOKMARKS = "CLIENT_CLIENT_BOOKMARKS_REQUEST_GET_ALL_CLIENT_BOOKMARKS",
    CALLBACK_GET_ALL_CLIENT_BOOKMARKS  = "CLIENT_CLIENT_BOOKMARKS_GET_ALL_CLIENT_BOOKMARKS",

}

export interface IRequestGetAllClientBookmarksAction extends Action {
    type: ClientClientBookmarksActionType.REQUEST_GET_ALL_CLIENT_BOOKMARKS;
    item: GetAllClientBookmarkByClientRequest;
}

export interface ICallbackGetAllClientBookmarksAction extends Action {
    type: ClientClientBookmarksActionType.CALLBACK_GET_ALL_CLIENT_BOOKMARKS;
    isSuccess: boolean;
    item?: GetAllClientBookMarkByClientResponse;
}

export type ClientClientBookmarksAction =
    IRequestGetAllClientBookmarksAction |
    ICallbackGetAllClientBookmarksAction ;

export interface IClientClientBookmarksActionCreator {
    requestGetAllClientBookmarksAction(item: GetAllClientBookmarkByClientRequest): IRequestGetAllClientBookmarksAction;

    callbackGetAllClientBookmarksAction(isSuccess: boolean, item?: GetAllClientBookMarkByClientResponse): ICallbackGetAllClientBookmarksAction;
}

class ActionCreator implements IClientClientBookmarksActionCreator {
    public requestGetAllClientBookmarksAction = (item: GetAllClientBookmarkByClientRequest): IRequestGetAllClientBookmarksAction => {
        return {
            type: ClientClientBookmarksActionType.REQUEST_GET_ALL_CLIENT_BOOKMARKS,
            item,
        };
    };

    public callbackGetAllClientBookmarksAction = (isSuccess: boolean, item: GetAllClientBookMarkByClientResponse): ICallbackGetAllClientBookmarksAction => {
        return {
            type: ClientClientBookmarksActionType.CALLBACK_GET_ALL_CLIENT_BOOKMARKS,
            isSuccess,
            item,
        };
    };
}

export const createClientClientBookmarksActionCreator = (): IClientClientBookmarksActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_client_bookmarks_action.ts